import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import './Popup.css';
import { useLocation } from "react-router-dom";
import { BiPhone, BiChevronRight } from "react-icons/bi"; // Import icons
import { Icon } from "@iconify/react/dist/iconify.js";

const CustomPopup = () => {
    const [show, setShow] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, 5000); // Show after 10 seconds
        return () => clearTimeout(timer);
    }, [location.pathname]);

    return (
        <>
            {show && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.82)",
                    zIndex: 99999,
                }}
                ></div>
            )}
            <Modal show={show} onHide={() => setShow(false)} style={{ zIndex: 99999 }} dialogClassName=" modal-lg">
                <Modal.Body className="p-0 rounded mymodal-body">
                    <div className="row g-0">
                        <div className="col-md-5 col-12 order-2 order-md-1">
                            <div className="left-section rounded">
                                <h2>Tax Season Savings Drive! Exclusive Offer for First-Time Customers!</h2>
                                <p>Get discounts on all our tax services and maximize your savings this tax season.
                                    Claim Your Savings Today!</p>
                                <a href="tel:+1 469 722 5480" style={{ textDecoration: "none" }} className="text-center">
                                    {/* <BiPhone size={20} />  */}
                                    <Button variant="success" className="d-flex align-items-center justify-content-center gap-2 ">
                                        <Icon icon="line-md:phone-call-twotone-loop" width="24" height="24" />

                                        Call Now
                                        {/* <BiChevronRight size={20} /> */}
                                        <BiChevronRight size={22} className="arrow-icon" />

                                    </Button>


                                </a>

                            </div>
                        </div>

                        <div className="col-md-7 col-12 order-1 order-md-2 position-relative right-section rounded">
                            <div className="popup-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center text-white text-center">
                                <Button
                                    className="position-absolute top-0 end-0 m-2 border-0 bg-transparent text-white"
                                    onClick={() => setShow(false)}
                                >
                                    <i className="bi bi-x-lg fs-4"></i>
                                </Button>

                                <p> <h2>Offer</h2> Save Up to <h3>15-25%</h3></p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>




        </>
    );
};

export default CustomPopup;
